import React from "react";

import { t } from "../../i18n";

import type { UserPreferences } from "../../userPreferences";

interface FontPresetSettingsProps {
  preferences: UserPreferences;
  onChange: (updates: Partial<UserPreferences>) => void;
}

export const FontPresetSettings: React.FC<FontPresetSettingsProps> = ({
  preferences,
  onChange,
}) => {
  const handleFontSizeChange = (
    size: keyof UserPreferences["fontPresets"],
    value: number,
  ) => {
    onChange({
      fontPresets: {
        ...preferences.fontPresets,
        [size]: value,
      },
    });
  };

  return (
    <div className="FontPresetSettings">
      <h3>{t("settings.fontPresets")}</h3>
      <p className="FontPresetSettings__description">
        {t("settings.fontPresetsDescription")}
      </p>
      <div className="FontPresetSettings__grid">
        <div className="FontPresetSettings__item">
          <label>{t("labels.small")} (S)</label>
          <input
            type="number"
            min="8"
            max="72"
            value={preferences.fontPresets?.small || 16}
            onChange={(e) =>
              handleFontSizeChange("small", parseInt(e.target.value, 10))
            }
          />
          <span>px</span>
        </div>
        <div className="FontPresetSettings__item">
          <label>{t("labels.medium")} (M)</label>
          <input
            type="number"
            min="8"
            max="72"
            value={preferences.fontPresets?.medium || 20}
            onChange={(e) =>
              handleFontSizeChange("medium", parseInt(e.target.value, 10))
            }
          />
          <span>px</span>
        </div>
        <div className="FontPresetSettings__item">
          <label>{t("labels.large")} (L)</label>
          <input
            type="number"
            min="8"
            max="72"
            value={preferences.fontPresets?.large || 28}
            onChange={(e) =>
              handleFontSizeChange("large", parseInt(e.target.value, 10))
            }
          />
          <span>px</span>
        </div>
        <div className="FontPresetSettings__item">
          <label>{t("labels.veryLarge")} (XL)</label>
          <input
            type="number"
            min="8"
            max="72"
            value={preferences.fontPresets?.extraLarge || 36}
            onChange={(e) =>
              handleFontSizeChange("extraLarge", parseInt(e.target.value, 10))
            }
          />
          <span>px</span>
        </div>
      </div>
    </div>
  );
};
